import service from "./../../../services/purchase/account";
import { arrayPushOrUpdateByID } from './../../../utils/toolkit';

export default {
    namespaced: true,
    state: {
        list: [],
        loading: false
    },
    mutations: {
        push: (state, payload) => state.list = arrayPushOrUpdateByID(state.list, payload),
        setLoading: (state, payload) => state.loading = payload 
    },
    getters: {
        list: state => state.list,
        loading: state => state.loading
    },
    actions: {
        search(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true)
                service.search(payload).then(response => {
                    context.commit("push", response.data)
                    resolve(response)
                }).catch(error => {
                    reject(error);
                }).finally(() => {
                    context.commit("setLoading", false)
                })
            })
        },
        push(context, payload) {
            context.commit("push", [payload])
        }
    }
}